module.exports = __webpack_public_path__ + "img/BendLogoParkPlaying.a50700b7.svg";